import { ReactElement } from "react";
import clsx from "clsx";

import { Column } from "@/components/Column";

export const SheetSectionContainer = ({
  children,
  className,
}: {
  children: ReactElement[];
  className?: string;
}) => {
  return (
    <Column
      className={clsx(
        "gap-4 border-t border-slate-200 pb-8 pt-8",
        className,
      )}
    >
      {children}
    </Column>
  );
};
